import { render, staticRenderFns } from "./AdminSteamBotOffer.vue?vue&type=template&id=6d30ab79&scoped=true&"
import script from "./AdminSteamBotOffer.vue?vue&type=script&lang=ts&"
export * from "./AdminSteamBotOffer.vue?vue&type=script&lang=ts&"
import style0 from "./AdminSteamBotOffer.vue?vue&type=style&index=0&id=6d30ab79&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d30ab79",
  null
  
)

export default component.exports
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QAvatar,QTooltip,QBtn,QIcon});
